export const GA_ID =
  process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID || "G-QNQ9MFT4G0";

export const AW_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID || "AW-18049615348";
